/**
 * collections.js
 * Purpose: Single source of truth for Firestore collection names, IndexedDB names, and tiny ID/slug helpers.
 */

export const COLLECTIONS = {
  // ===== System-scoped =====
  systemAppUsers: "pp_app_users",
  systemAccountTypes: "pp_account_types",
  systemTransactionTypes: "pp_transaction_types",
  systemCurrencyList: "pp_currency_list",
  systemBetaInvitations: "pp_beta_invitations",
  systemIncomeTaxConfig: "pp_income_tax_config",
  systemFormatsTransactions: "pp_system_formats_transactions",
  systemFormatsAccounts: "pp_system_formats_accounts",
  systemFormatsTags: "pp_system_formats_tags",

  // ===== User-scoped =====
  userAccounts: "user_accounts",
  userTags: "user_tags",
  userTransactions: "user_transactions",
  userRules: "user_rules",
  userConfigTransactions: "user_config_transactions",
  userBudgets: "user_budgets",

  // ===== Meta / changes =====
  userTransactionsMeta: "user_transactions_meta",
  userTransactionChanges: "user_transaction_changes", 

  // ===== Income Tax (user-scoped) =====
  userInTaxForecasts: "user_in_tax_forecasts",
  userInTaxSources:   "user_in_tax_sources",
  userInTaxPaystubs:  "user_in_tax_paystubs",
};

export const LOCAL_DB = {
  name: "pp-cache",
  version: 2,
  stores: {
    txByQuery: "txByQuery",
  },
};

export const userScopedId = (uid, slugOrId) => `${uid}:${slugOrId}`;

export const slugify = (s) =>
  String(s ?? "")
    .normalize("NFKC")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, " ")
    .replace(/[^a-z0-9 _.-]/g, "")
    .replace(/[ .]+/g, "-")
    .replace(/-+/g, "-");
